import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { queueTrack } from '../api/client.js';
import { djSearchQueryKeyPrefix, djViewQueryKey } from '../api/queryKeys.js';

import type { ChannelId, DjView, PartySlug } from '@mixwire/contracts';

type QueueTrackVariables = {
  readonly slug: PartySlug;
  readonly channelId: ChannelId;
  /** A Spotify track id, or any link form somebody pasted. */
  readonly track: string;
};

export const useQueueTrack = (): UseMutationResult<DjView, Error, QueueTrackVariables> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ slug, channelId, track }: QueueTrackVariables) =>
      queueTrack(slug, channelId, track),
    onSuccess: (djView, { slug, channelId }) => {
      queryClient.setQueryData(djViewQueryKey(slug, channelId), djView);
      // Adding a track can clear it from the wants list, which the search results report on.
      void queryClient.invalidateQueries({ queryKey: djSearchQueryKeyPrefix(slug, channelId) });
    },
  });
};
